export const GET_SECURITY_EVENTS = "GET_SECURITY_EVENTS";
